function collectionItemsInit() {
  const collectionItems = document.querySelectorAll('[data-collection-item]');
  if (!collectionItems) { return; }
  collectionItems.forEach(item => {
    collectionItemInit(item);
  });
}

function collectionItemInit(item) {
  const helpOpen = item.querySelector('[data-collection-item-help-toggle]');
  const helpClose = item.querySelector('[data-collection-item-help-close]');

  if (!helpOpen || !helpClose) { return; }

  helpOpen.addEventListener('click', () => {
    item.classList.add('flipped');
    item.classList.add('flipping');
    setTimeout(() => item.classList.remove('flipping'), 500);
  });

  helpClose.addEventListener('click', () => {
    item.classList.remove('flipped');
    item.classList.add('flipping');
    setTimeout(() => item.classList.remove('flipping'), 500);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  collectionItemsInit();
});


function filterListMobileScroll() {
  const filters = document.querySelectorAll('[data-tag-filter]');

  if (!filters) { return; }

  function calcWidth() {
    filters.forEach(filter => {
      const filterList = filter.querySelector('[data-tag-filter-list]');
      const filterListItems = filter.querySelectorAll('[data-tag-filter-list] > li');

      let filterWidth = 0;
      filterListItems.forEach(filterListItem => {
        const itemStyle = filterListItem.currentStyle || window.getComputedStyle(filterListItem);
        filterWidth += filterListItem.offsetWidth + parseFloat(itemStyle.marginRight);
      });

      filterList.style.width = `${filterWidth + 24}px`;
    });
  }

  function resetWidth() {
    filters.forEach(filter => {
      const filterList = filter.querySelector('[data-tag-filter-list]');
      filterList.removeAttribute('style');
    });
  }

  const breakpoint = window.matchMedia('(max-width: 750px)');

  breakpoint.addListener(breakpointCheck);

  function breakpointCheck() {
    if (breakpoint.matches === true) {
      setTimeout(() => {
        calcWidth();
      }, 500);
    } else {
      resetWidth();
    }
  }

  breakpointCheck();
}

document.addEventListener('DOMContentLoaded', () => {
  filterListMobileScroll();
});

document.addEventListener('shopify:section:load', () => {
  filterListMobileScroll();
});

// Check if Yotpo is initialized
function yotpoSliderInit() {
  const reviewsWrapper = document.querySelector('[data-product-reviews]');
  const productReviews = document.querySelector('[data-product-template-reviews]');
  let mySwiper = null;
  const isProductTemplate = (productReviews !== null);

  const yotpoLoaded = setInterval(() => {
    const yotpoWrapper = document.querySelector('.main-widget');
    // If no reviews, add class and bail
    if (yotpoWrapper != null && yotpoWrapper.classList.contains('yotpo-no-reviews')) {
      reviewsWrapper.classList.add('no-reviews');
      clearInterval(yotpoLoaded);
      return;
    }

    // If reviews, make swiper, add click listener
    const yotpoReview = document.querySelector('.yotpo-review');
    if (yotpoReview !== null) {
      rejigLayout();
      rejigReviews();
      mySwiper = makeSwiper();
      disableSwiperOnDesktop();
      reviewLoadedChecker();
      clearInterval(yotpoLoaded);
    }
  }, 100);

  // Cancel interval if no reviews after 10 seconds
  setTimeout(() => {
    clearInterval(yotpoLoaded);
  }, 10000);

  function makeSwiper() {
    const yotpoReviews = document.querySelector('.yotpo-reviews');
    const sliderContainer = document.createElement('div');
    sliderContainer.classList.add('swiper-container', 'reviews-slider');
    sliderContainer.setAttribute('data-product-reviews-swiper-container', '');
    const sliderWrapper = document.createElement('div');
    sliderWrapper.classList.add('swiper-wrapper');
    sliderContainer.prepend(sliderWrapper);
    yotpoReviews.prepend(sliderContainer);

    initSwiper(sliderContainer);

    const yotpoReviewsList = yotpoReviews.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
    if (yotpoReviewsList !== null) {
      const yotpoReviewArrays = [...yotpoReviewsList];
      yotpoReviewArrays.forEach((review) => {
        review.classList.add('swiper-slide');
        mySwiper.appendSlide(review);
      });
    }
    return mySwiper;
  }

  function initSwiper(sliderContainer) {
    const options = {
      slidesPerView: 'auto',
      centeredSlides: false,
      freeMode: true,
      loop: false,
      mousewheel: {
        forceToAxis: true,
        eventsTarget: '.reviews-slider',
        invert: true,
      },
      navigation: {
        nextEl: '.swiper-nav__btn--next',
        prevEl: '.swiper-nav__btn--prev',
      },
    };

    mySwiper = new Swiper(sliderContainer, options);
  }

  function rejigLayout() {
    const bottomLine = reviewsWrapper.querySelector('.yotpo-bottomline');
    const yotopLabel = reviewsWrapper.querySelector('.yotpo-label');
    const yotopLabelClear = yotopLabel.querySelector('.yotpo-clr');
    const writeReviewButton = reviewsWrapper.querySelector('.write-review-button');
    const bottomLineEls = document.querySelectorAll('[data-yotpo-bottomline-container]');

    if (bottomLine == null) { return; }
    bottomLine.classList.remove('pull-left');
    writeReviewButton.classList.remove('pull-right');
    yotopLabelClear.remove();
    yotopLabel.appendChild(bottomLine);
    yotopLabel.appendChild(writeReviewButton);

    if (bottomLineEls == null) { return; }
    const bottomLineClone = bottomLine.cloneNode(true);
    bottomLineEls.forEach(bottomLineEl => {
      bottomLineEl.append(bottomLineClone);
    });
  }

  function rejigReviews() {
    const yotpoReviewsList = document.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
    yotpoReviewsList.forEach(review => {
      const reviewHeader = review.querySelector('.yotpo-header');
      const reviewFooter = review.querySelector('.yotpo-footer');
      const reviewStars = review.querySelector('.yotpo-review-stars');
      const reviewStarsClone = reviewStars.cloneNode(true);
      const reviewName = review.querySelector('.yotpo-user-name');
      const reviewNameClone = reviewName.cloneNode(true);
      const reviewVerified = reviewHeader.querySelector('.label-with-tooltip');
      const reviewhelpfulLabel = review.querySelector('.label-helpful');

      if (reviewVerified !== null) {
        const reviewVerifiedClone = reviewVerified.cloneNode(true);
        reviewVerifiedClone.classList.add('verified-buyer');
        reviewFooter.prepend(reviewVerifiedClone);
        reviewVerified.remove();
      }
      reviewHeader.appendChild(reviewStarsClone);
      reviewFooter.prepend(reviewNameClone);

      reviewhelpfulLabel.innerText = 'Was This Helpful?';

      // Cleanup
      reviewName.remove();
      reviewStars.remove();
    });
  }

  function reviewLoadedChecker() {
    const yotpoReviews = document.querySelector('.yotpo-reviews');
    document.querySelectorAll('.yotpo-page-element').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (trigger.classList.contains('yotpo-disabled')) {
          return;
        }
        yotpoReviews.style.visibility = 'hidden';
        const checkReviewsLoading = setInterval(() => {
          const yotpoReviewsList = yotpoReviews.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
          if (yotpoReviewsList != null && yotpoReviewsList.length > 0 && !yotpoReviewsList[0].classList.contains('swiper-slide')) {
            rejigReviews();
            mySwiper = makeSwiper();
            disableSwiperOnDesktop();
            yotpoReviews.style.visibility = 'visible';
            clearInterval(checkReviewsLoading);
            reviewLoadedChecker();
          }
        }, 50);
      });
    });
  }

  const breakpoint = window.matchMedia('(min-width: 750px)');
  breakpoint.addListener(disableSwiperOnDesktop);

  function disableSwiperOnDesktop() {
    if (!isProductTemplate) { return; }
    const swiperContainer = document.querySelector('[data-product-reviews-swiper-container]');
    if (swiperContainer === null) { return; }

    if (breakpoint.matches === true) {
      if (mySwiper !== null && typeof mySwiper !== 'undefined') {
        swiperContainer.classList.add('destroyed');
        mySwiper.destroy(true, true);
        mySwiper = null;
      }
    } else {
      initSwiper(swiperContainer);
      swiperContainer.classList.remove('destroyed');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  yotpoSliderInit();
});

// type steps

function collectionTypeSteps() {
  const triggers = document.querySelectorAll('[data-type-steps-open]');

  if (!triggers) { return; }

  const details = document.querySelectorAll('[data-type-steps-content]');
  const exits = document.querySelectorAll('[data-type-steps-close]');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const index = parseInt(trigger.getAttribute('data-type-steps-open'), 10) - 1;
      details.forEach((detail) => {
        detail.classList.remove('active');
      });
      details[index].classList.add('active');
    });
  });

  exits.forEach((exit) => {
    exit.addEventListener('click', () => {
      const index = parseInt(exit.getAttribute('data-type-steps-close'), 10) - 1;
      details[index].classList.remove('active');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  collectionTypeSteps();
});

// type collections js

function customCollectionSorting() {
  const collections = document.querySelectorAll('[data-type-collection]');

  collections.forEach(collection => {
    const collectionGrid = collection.querySelector('[data-type-collection-grid]');
    const collectionItems = collection.querySelectorAll('[data-collection-item]');
    const collectionFilterTags = collection.querySelectorAll('[data-collection-filter-tag]');

    if (!collectionFilterTags || !collectionItems) { return; }

    collectionFilterTags.forEach(collectionFilterTag => {
      const tag = collectionFilterTag.dataset.collectionFilterTag;

      collectionFilterTag.addEventListener('click', () => {
        const matchingItems = [...collectionItems].filter(item => item.dataset.collectionItemTags.includes(tag));

        setTimeout(() => {
          if (tag === 'all') {
            collectionGrid.classList.remove('filtered');
          } else {
            collectionGrid.classList.add('filtered');
          }
        }, 500);

        collectionFilterTags.forEach(button => button.classList.remove('selected'));
        collectionFilterTag.classList.add('selected');

        matchingItems.forEach(matchingItem => {
          matchingItem.classList.add('match');
        });

        if (matchingItems.length < 1) { return; }

        collectionGrid.classList.add('fadeout');
      });
    });

    collectionGrid.addEventListener('transitionend', (event) => {
      if (!event.target.classList.contains('collection-grid')) { return; }
      if (event.target.classList.contains('fadeout')) {
        collectionItems.forEach(collectionItem => {
          if (collectionItem.classList.contains('match')) {
            collectionItem.classList.remove('match', 'hide');
          } else {
            collectionItem.classList.add('hide');
          }
        });
        collectionGrid.classList.remove('fadeout');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  customCollectionSorting();
});

document.addEventListener('shopify:section:load', () => {
  customCollectionSorting();
});
